import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export var validateName = genericValidateName([
    exactValidator('habitats'),
    uuidValidator(),
    exactValidator('meetingEntitlements'),
    uuidValidator(),
]);
export var NameToID = function (name) {
    validateName(name); // throws if invalid
    var parts = name.split(SEPARATOR);
    return {
        habitatID: parts[1],
        meetingEntitlementID: parts[3],
    };
};
